import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import type { ReactNode } from "react";

import { getUserDisplayName } from "@bw/shared/utils";

import { PlatformPage } from "@/components/PlatformPage";

import type { PlatformUserDetail } from "../api";

/** User detail page heading and the preserved operator action row. */
export function UserDetailHeader({
  user,
  onNotify,
  onSendReset,
  onBan,
  onUnban,
  children,
}: {
  user: PlatformUserDetail;
  onNotify: () => void;
  onSendReset: () => void;
  onBan: () => void;
  onUnban: () => void;
  children: ReactNode;
}) {
  const actions = (
    <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: "wrap" }}>
      <Button type="button" size="small" variant="outlined" onClick={onNotify}>
        Notify user
      </Button>
      {user.email ? (
        <Button
          type="button"
          size="small"
          variant="outlined"
          onClick={onSendReset}
        >
          Send reset link
        </Button>
      ) : null}
      {user.status === "banned" ? (
        <Button
          type="button"
          size="small"
          color="success"
          variant="outlined"
          onClick={onUnban}
        >
          Unban user
        </Button>
      ) : (
        <Button
          type="button"
          size="small"
          color="error"
          variant="contained"
          onClick={onBan}
        >
          Ban user
        </Button>
      )}
    </Stack>
  );

  return (
    <PlatformPage
      title={getUserDisplayName(user.display_name, user.uid)}
      actions={actions}
    >
      <Stack spacing={3}>{children}</Stack>
    </PlatformPage>
  );
}
